<template>
  <div class="bg-lh_gray w-screen flex flex-col items-center p-10 space-y-3">
    <div class="flex space-x-5 w-[17vh] lg:w-[20vw] justify-center">
      <img alt="logo"
           src="https://www.salviharps.com/wp-content/themes/salviharps2016/dist/images/logo-salvi-harps.png"
           class="w-full sm:w-1/2 lg:w-1/3"
      />
      <img alt="logo"
           src="https://160days.lyonhealy.com/logo-lyon-healy.png"
           class="w-full sm:w-1/2 lg:w-1/3"
      />
    </div>
    <div class="flex flex-col">
      <div class="flex flex-col items-center">
        <p class="footerText">
          {{ $t('address') }} - {{ $t('companyEmail') }} - {{ $t('phoneNumber') }}
        </p>
        <p class="footerText px-2 border-t border-lh_red">{{ $t('rights') }} {{ currentYear }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import appVariables from '@/config/appVariables.json';

export default {
  data() {
    return {
      footerContents: appVariables,
      currentYear: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapGetters('auth', ['authenticated', 'isSuperAdmin']),
  },
};
</script>

<style>
.footerText {
  @apply text-xs lg:text-sm text-lh_light_gray pb-1 text-center
}
</style>
